import RelationshipBadge from "./RelationshipBadge";
import ContextBadges from "./ContextBadges";
import { contactProfileForEntry } from "../lib/privateContactProfile";
import { initialsFor } from "../lib/initials";
import { relationshipColor } from "../lib/relationshipColors";

function StrengthDotsSmall({ strength }) {
  const filled = strength === "strong" ? 3 : strength === "moderate" ? 2 : 1;
  return (
    <div className="strength-dots">
      {[1, 2, 3].map((i) => (
        <div key={i} className={`strength-dot ${i <= filled ? "filled" : ""}`} />
      ))}
    </div>
  );
}

export default function ProfileCard({ connection, isActive, onSelect, viaName }) {
  const { relationship_type, connection_strength, id } = connection;
  const profile = contactProfileForEntry(connection);
  const name = profile.full_name || connection.recipient_name || connection.recipient_phone || "Unknown";
  const meta = profile.role || profile.company || profile.organization || profile.school || "";
  const photo = connection.photo_url || profile.profile_photo_url;

  let rowClass = "connection-row";
  if (isActive) rowClass += " active";

  return (
    <button className={rowClass} onClick={() => onSelect(id)}>
      <div className="conn-avatar" style={{ background: relationshipColor(relationship_type) }}>
        {photo ? <img src={photo} alt={name} /> : initialsFor(name)}
      </div>
      <div className="conn-info">
        <div className="conn-name">{name}</div>
        {meta && <div className="conn-meta">{meta}</div>}
        {viaName && <div className="conn-via">via {viaName}</div>}
      </div>
      <div className="conn-right">
        {connection.contexts?.length > 0 && (
          <ContextBadges contexts={connection.contexts} compact />
        )}
        {connection_strength && <StrengthDotsSmall strength={connection_strength} />}
        {relationship_type && <RelationshipBadge type={relationship_type} />}
      </div>
    </button>
  );
}
